"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var clone = require('clone');
var tv4 = require('tv4');
var Card = require('./card');
var ConditionCard = /*#__PURE__*/function (_Card) {
  _inherits(ConditionCard, _Card);
  var _super = _createSuper(ConditionCard);
  function ConditionCard(opt) {
    var _this;
    _classCallCheck(this, ConditionCard);
    _this = _super.call(this, opt);
    _this.type = 'CONDITION';
    _this.details = {
      cards: [],
      conditions: {},
      description: null,
      header: '',
      title: null,
      value: null
    };
    if (opt && opt.details) {
      _this.fillObject(clone(opt.details));
    }
    return _this;
  }
  _createClass(ConditionCard, [{
    key: "getOptions",
    value: function getOptions() {
      return Object.keys(this.details.conditions);
    }
  }, {
    key: "setCondition",
    value: function setCondition(value) {
      this.fillCards(this.details.conditions[value]);
    }
  }, {
    key: "fillObject",
    value: function fillObject(details) {
      this.details.conditions = details.conditions || {};
      this.details.description = details.description || null;
      this.details.header = details.header || '';
      this.details.title = details.title || null;
      this.details.value = details.value || null;
      this.fillCards(details.cards);
      this.isValid = !!this.details.value && !this.details.cards.some(function (c) {
        return !c.isValid;
      });
    }
  }, {
    key: "fillCards",
    value: function fillCards(cards) {
      if (Array.isArray(cards)) {
        var _require = require('../../helper/card-factory'),
          createCardFactory = _require.createCardFactory; // eslint-disable-line
        this.details.cards = cards.map(function (card) {
          return createCardFactory(card.type, _objectSpread({}, card));
        });
      }
    }
  }, {
    key: "calculateCounts",
    value: function calculateCounts(count) {
      var result = _objectSpread({}, count);
      this.details.cards.forEach(function (card) {
        if (card.details.countLabel) {
          result[card.details.countLabel] = (result[card.details.countLabel] || 0) + card.details.count;
        }
      });
      return result;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, ConditionCard.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'condition-card.schema.json',
        type: 'object',
        allOf: [{
          $ref: 'card.schema.json'
        }, {
          properties: {
            details: {
              conditions: {
                type: 'object'
              },
              cards: {
                type: 'array',
                items: {
                  type: 'object'
                }
              },
              description: {
                type: ['string', 'null']
              },
              header: {
                type: 'string'
              },
              title: {
                type: ['string', 'null']
              },
              value: {
                type: ['string', 'null']
              }
            }
          }
        }],
        required: Object.keys(this)
      };
    }
  }]);
  return ConditionCard;
}(Card);
tv4.addSchema(Card.schema());
module.exports = ConditionCard;